import { types } from "mobx-state-tree";
import { AutoscalerModel } from "./autoscaler";
import { TaintModel } from "./common";
import { NetworkingModel } from "./networking";
import { PreInstallScriptProperty } from "./preInstallScript";

export const GcpPoolModel = types.model({
  name: types.string,
  labels: types.frozen(),
  taints: types.array(TaintModel),
  machineType: types.string,
  assignPublicIP: types.optional(types.boolean, false),
  preemptible: types.optional(types.boolean, false),
  zone: types.string,
  overrideImage: types.maybe(
    types.model({
      recommended: types.maybe(types.string),
      family: types.maybe(
        types.model({
          project: types.optional(types.string, ""),
          family: types.optional(types.string, ""),
        }),
      ),
      exact: types.maybe(types.string),
    }),
  ),
  bootDiskSize: types.optional(types.number, 20),
  minSize: types.number,
  maxSize: types.number,
  subnet: types.string,
  localPersistentDisks: types.maybe(types.number),
});

export const GcpProviderModel = types.model("GCP Provider", {
  projectId: types.string,
  region: types.string, // readonly after creation
  labels: types.frozen(),
  tags: types.frozen(),
  metadata: types.frozen(),
  network: types.string,
  saKeyLink: types.string,
  image: types.model({
    recommended: types.maybe(types.string),
    family: types.maybe(
      types.model({
        project: types.optional(types.string, ""),
        family: types.optional(types.string, ""),
      }),
    ),
    exact: types.maybe(types.string),
  }),
  nodePools: types.array(GcpPoolModel),
  networking: NetworkingModel,
  preInstallScript: PreInstallScriptProperty,
  autoscaler: AutoscalerModel,
});
